export function effectiveDashboardHubIds(sectionHubIds, globalHubIds) {
  const section = Array.isArray(sectionHubIds) ? sectionHubIds.map(String).filter(Boolean) : [];
  if (section.length) return section;
  return Array.isArray(globalHubIds) ? globalHubIds.map(String).filter(Boolean) : [];
}

export function hubIdsQueryParam(canFilterHubs, hubIds) {
  if (!canFilterHubs || !hubIds?.length) return {};
  return { hub_ids: hubIds.join(',') };
}
